import React, { Component } from 'react';
import 'rc-calendar/assets/index.css';
import 'rc-time-picker/assets/index.css';
import Calendar from 'rc-calendar';
import DatePicker from 'rc-calendar/lib/Picker';
import locale from 'rc-calendar/lib/locale/pt_BR';
import { Form, Input, Icon, Button, Spin, Select, Checkbox } from 'antd';
import moment from 'moment-timezone';
import NumberFormat from 'react-number-format';

const InputGroup = Input.Group;
const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

class InputForm extends Component {

    state = {
        valid: null,
        opened: false
    };

    onChange = (event) => {
        const { validator, onChange, masker } = this.props;
        if (masker) {
            event.target.value = masker(event.target.value);
        }
        if (validator) {
            this.setState({ valid: !!validator(event.target.value) })
        }
        onChange(event);
    }

    onDateChange = date => {
        const { id, dateFormat } = this.props;
        const dateString = date.format(dateFormat);
        this.onChange({
            target: {
                value: dateString,
                id: id,
            }
        });
    }

    onCheckboxChange = event => {
        const { id, checked } = event.target;
        const { onChange } = this.props;
        onChange({
            target: {
                value: checked,
                id: id,
            }
        });
    }

    onSelectChange = value => {
        const { id } = this.props;
        this.onChange({
            target: {
                id: id,
                value: value
            }
        })
    }

    focus = () => {
        this.refs.Input.focus();
    }

    blur = () => {
        this.refs.Input.blur();
    }

    onFocusDatePicker = () => {
        if (this.props.autoOpen) {
            this.setState({ opened: true });
        }
    }

    onOpenChange = (opened) => {
        this.setState({ opened });
    }

    openDatePicker = () => {
        this.setState({ opened: true });
    }

    isValid = () => {
        if (!this.props.required)
            return true;

        const { validator, value } = this.props;
        let valid = false;
        if (validator) {
            valid = !!validator(value);
        } else {
            valid = !!value;
        }
        this.setState({ valid });

        return valid;
    }

    stringDateToMoment = (stringDate) => {
        const date = moment(stringDate, this.props.dateFormat, true);
        return date && date.isValid() ? date : null;
    }

    render() {
        const { label, id, errorMessage, type, dateFormat, validator, masker, value,
            required, onChange, formItemLayout, onDateSelect, precision, data,
            fetching, multiple, filterOption, onSearch, decimalScale, ...others } = this.props;
        const { valid, opened } = this.state;

        let CustomInput;
        if (type === 'date') {
            CustomInput = (
                <div>
                    <InputGroup compact>
                        <Input id={id} value={value}
                            type="text"
                            style={{ width: 150 }}
                            {...others}
                            onChange={this.onChange}
                            onFocus={this.onFocusDatePicker}
                            ref="Input" />
                        <Button onClick={this.openDatePicker} htmlType="button">
                            <Icon type="calendar" style={{ color: 'rgba(0,0,0,0.4)' }} />
                        </Button>
                    </InputGroup>
                    <DatePicker
                        animation="slide-up"
                        calendar={(
                            <Calendar
                                formatter={dateFormat}
                                showDateInput={false}
                                autoFocus={false}
                                onSelect={onDateSelect}
                                locale={locale}
                            />
                        )}
                        onChange={this.onDateChange}
                        open={opened}
                        onOpenChange={this.onOpenChange}
                        autoFocus={false}
                        value={this.stringDateToMoment(value)}
                    >
                        {() => <span></span>}
                    </DatePicker>
                </div>
            )
        } else if (type === 'textarea') {
            CustomInput = (
                <TextArea id={id} value={value} type={type}
                    {...others}
                    onChange={this.onChange}
                    ref="Input" />
            )
        } else if (type === 'checkbox') {
            CustomInput = (
                <Checkbox id={id} value={value} checked={value} type={type}
                    {...others}
                    onChange={this.onCheckboxChange}
                    ref="Input"
                />
            )
        } else if (type === 'number') {
            CustomInput = (
                <NumberFormat
                    id={id}
                    value={value || 0}
                    {...others}
                    ref="Input"
                    thousandSeparator="."
                    decimalSeparator=","
                    className="ant-input camposNumberForm"
                    autoComplete="off"
                    isNumericString
                    fixedDecimalScale
                    decimalScale={decimalScale}
                    allowEmptyFormatting
                    onValueChange={values => {
                        this.onChange({
                            target: {
                                id: id,
                                value: values.floatValue,
                                // console: 'teste'//values.floatValue.toFixed(2)
                            }
                        })
                    }}
                />
            )
        } else if (type === "select") {
            const selectOptions = data.map(d => <Option key={d.key}>{d.label}</Option>);
            const notFoundContent = fetching ? <Spin size="small" /> : 'Digite para Buscar';
            const mode = multiple ? 'multiple' : 'default';
            CustomInput = (
                <Select
                    {...others}
                    ref="Input"
                    mode={mode}
                    value={value}
                    labelInValue
                    notFoundContent={notFoundContent}
                    filterOption={!onSearch ? filterOption : false}
                    onChange={this.onSelectChange}
                    onSearch={onSearch}
                >
                    {selectOptions}
                </Select>
            );

        } else {
            CustomInput = (
                <Input
                    {...others}
                    ref="Input"
                    id={id}
                    value={value}
                    type={type}
                    onChange={this.onChange}
                />
            )
        }

        return (
            <FormItem
                // validateStatus={valid === null ? null : valid ? "success" : "error"}
                // help={valid === false ? errorMessage : null}
                // label={label}
                {...formItemLayout}
            >
                {CustomInput}
            </FormItem>
        )
    }
}

InputForm.defaultProps = {
    data: [],
    decimalScale: 2,
    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
}

export default InputForm;



// WEBPACK FOOTER //
// ./src/components/InputForm.js